import { render, staticRenderFns } from "./nonfee.vue?vue&type=template&id=0f3f55d7&scoped=true&"
import script from "./nonfee.vue?vue&type=script&lang=js&"
export * from "./nonfee.vue?vue&type=script&lang=js&"
import style0 from "./nonfee.vue?vue&type=style&index=0&id=0f3f55d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3f55d7",
  null
  
)

export default component.exports